import lang from '@/lang'

export enum MultiSelectTypes {
  All = 'all',
  User = 'user',
  Client = 'client',
  Customer = 'customer',
  CustomerContact = 'customerContact',
  Supplier = 'supplier',
  SupplierContact = 'supplierContact',
  External = 'external',
}

export const MultiSelectTypeOptions = {
  all: { type: MultiSelectTypes.All, label: lang.multiSelect.types.label.all },
  user: { type: MultiSelectTypes.User, label: lang.multiSelect.types.label.user },
  client: { type: MultiSelectTypes.Client, label: lang.multiSelect.types.label.client },
  customer: { type: MultiSelectTypes.Customer, label: lang.multiSelect.types.label.customer },
  supplier: { type: MultiSelectTypes.Supplier, label: lang.multiSelect.types.label.supplier },
}
